/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOutTrackingPresetCounts } from './CarveOutTrackingPresetCounts';
import {
    CarveOutTrackingPresetCountsFromJSON,
    CarveOutTrackingPresetCountsFromJSONTyped,
    CarveOutTrackingPresetCountsToJSON,
} from './CarveOutTrackingPresetCounts';

/**
 * 
 * @export
 * @interface FindCarveOutTrackingPresetCounts200Response
 */
export interface FindCarveOutTrackingPresetCounts200Response {
    /**
     * 
     * @type {CarveOutTrackingPresetCounts}
     * @memberof FindCarveOutTrackingPresetCounts200Response
     */
    data?: CarveOutTrackingPresetCounts;
}

/**
 * Check if a given object implements the FindCarveOutTrackingPresetCounts200Response interface.
 */
export function instanceOfFindCarveOutTrackingPresetCounts200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindCarveOutTrackingPresetCounts200ResponseFromJSON(json: any): FindCarveOutTrackingPresetCounts200Response {
    return FindCarveOutTrackingPresetCounts200ResponseFromJSONTyped(json, false);
}

export function FindCarveOutTrackingPresetCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindCarveOutTrackingPresetCounts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CarveOutTrackingPresetCountsFromJSON(json['data']),
    };
}

export function FindCarveOutTrackingPresetCounts200ResponseToJSON(value?: FindCarveOutTrackingPresetCounts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CarveOutTrackingPresetCountsToJSON(value.data),
    };
}

